import React, { useMemo } from "react";

import Navbar from "components/MI/Navbar";
import UserMenu from "components/layout/userMenuNew";

import BillingData from "./steps/BillingData";
import DirectDebit from "./steps/DirectDebit";
import Meter from "./steps/Meter";
import Registration from "./steps/Registration";
import SuccessRegister from "./steps/SuccessRegister";

import { useAddNewunit } from "./hooks/useAddNewUnit";

import { Container, CustomScroll, Divisor, Header, Title } from "./styles";

const AddNewUnit: React.FC = () => {
  const { step } = useAddNewunit();

  const stepComponent = useMemo(() => {
    const components = {
      1: <Registration />,
      2: <Meter />,
      3: <BillingData />,
      4: <DirectDebit />,
      5: <SuccessRegister />,
    };

    return components[step] || <Registration />;
  }, [step]);

  return (
    <Navbar selected="adicionar-nova-unidade">
      <UserMenu />
      <CustomScroll>
        <Container>
          <Header>
            <Title>Adicionar nova unidade</Title>
          </Header>
          <Divisor />
          {stepComponent}
        </Container>
      </CustomScroll>
    </Navbar>
  );
};

export default AddNewUnit;
